
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 20 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M8.344 17.868c-3.498 0-5.434-.658-5.77-1.039.294-3.2 2.57-5.234 5.826-5.234 1.059 0 2 .186 2.801.553a5.633 5.633 0 012.144-1.024 5.654 5.654 0 00-1.185-.845c.807-.867 1.61-1.996 1.61-3.961 0-3.065-2.409-5.56-5.37-5.56-2.962 0-5.37 2.495-5.37 5.56 0 1.967.935 3.07 1.686 3.941-2.42 1.264-3.971 4.48-3.971 6.645 0 2.577 5.313 2.857 7.599 2.857.436 0 .984-.01 1.584-.046a5.617 5.617 0 01-.788-1.86c-.257.008-.52.013-.796.013zM8.4 2.651c1.953 0 3.542 1.645 3.542 3.667S10.354 9.985 8.4 9.985c-1.954 0-3.542-1.645-3.542-3.667S6.446 2.65 8.4 2.65z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M19.274 17.242v-1.245l-.673-.24a.964.964 0 01-.547-1.322l.306-.644-.88-.88-.645.306a.965.965 0 01-1.322-.547l-.24-.673H14.03l-.24.673a.964.964 0 01-1.321.547l-.645-.306-.88.88.306.645a.962.962 0 01-.547 1.322l-.673.239v1.245l.673.239a.962.962 0 01.547 1.322l-.307.645.881.88.645-.306a.962.962 0 011.321.547l.24.673h1.245l.237-.669a.975.975 0 01.544-.572.955.955 0 01.776.018l.648.31.88-.881-.306-.645a.965.965 0 01.548-1.322l.673-.24zm-4.622 1.072a1.695 1.695 0 11-.001-3.39 1.695 1.695 0 010 3.39z"}})])
          )
        }
      }
    